import { Component, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConfigService } from './services/config.service';
import { IdleService } from './services/idle.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  constructor(
    private configService: ConfigService,
    private idleService:  IdleService, //husk å beholde denne selv om den ikke er i bruk her, den trigger en configureIdle i constructor når config har lastet inn
    private swUpdate: SwUpdate) {

    window.addEventListener('beforeinstallprompt', (event) => {
      console.log('beforeinstallprompt caught');
      console.log(event);
    });
  }

  ngOnInit(): void {

    if (this.swUpdate.isEnabled) {

      const updatesAvailable = this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
          map(evt => ({
            type: 'UPDATE_AVAILABLE',
            current: evt.currentVersion,
            available: evt.latestVersion
          })
          )
        )
        .subscribe(
          (evt) => {
            console.log(evt.available);
            console.log('Funnet ny versjon: ' + evt.available.hash);
            console.log(evt.current);
            console.log('Oppdaterer fra versjon: ' + evt.current.hash);

            let message = 'En ny versjon er tilgjengelig. Ønsker du å oppdatere?';
            if (confirm(message)) {
              window.location.reload();
            }
          }
        );

    }

    this.configService.loadData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

}
